<ng-container *ngIf="showSucceessInfo; else showEmailInput">
  <p [innerHtml]="'forgotPasswordPage.resetPasswordText' | translate : { email }"></p>
  <button (click)="back()" pm-button [pmType]="'primary'" type="submit" class="mt-[25px] max-md:mb-[20px] w-[165px] max-xs:w-full">
    {{ 'forgotPasswordPage.backButton' | translate }}
  </button>
</ng-container>

<ng-template #showEmailInput>
  <p class="font-medium">{{ 'forgotPasswordPage.forgotPasswordText' | translate }}</p>

  <form
    nz-form
    [nzLayout]="'vertical'"
    [formGroup]="form"
    (ngSubmit)="resetPassword()"
    novalidate
    class="mt-[25px]">
    <nz-form-item class="max-w-[368px]">
      <nz-form-label nzFor="email">{{ 'forgotPasswordPage.form.email.label' | translate }}</nz-form-label>
      <nz-form-control [nzErrorTip]="emailErrorTpl">
        <input
          nz-input
          placeholder="{{ 'forgotPasswordPage.form.email.placeholder' | translate }}"
          formControlName="email"
          name="email"
          type="email"
          id="email" />
        <ng-template #emailErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            {{ 'forgotPasswordPage.form.email.isRequired' | translate }}
          </ng-container>
          <ng-container *ngIf="control.hasError('email')">
            {{ 'forgotPasswordPage.form.email.isInvalid' | translate }}
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

    <button pm-button [pmType]="'primary'" type="submit" class="max-md:mb-[20px] max-xs:w-full">
      {{ 'forgotPasswordPage.form.resetButton' | translate }}
    </button>
  </form>
</ng-template>
